import { FlexmonsterPivotModule } from "ng-flexmonster";
import {
  CUSTOM_ELEMENTS_SCHEMA,
  ErrorHandler,
  ModuleWithProviders,
  NgModule,
  NO_ERRORS_SCHEMA,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { GlobalErrorHandlerService } from "./services/global-error-handler.service";
import { ToastService } from "./services/message/toast.service";
import { TRANSLATION_PROVIDERS } from "./services/translate/translations";
import { TranslatePipe } from "./services/translate/translate.pipe";
import { TranslateService } from "./services/translate/translate.service";
import { UserService } from "./services/user.service";
import { UtilService } from "./services/util.service";
import { KlSweetAlertService } from "./services/message/kl-sweet-alert.service";
import { GridContainerComponent } from "./components/grid-container/grid-container.component";
// wijmo
import { WjCoreModule } from "wijmo/wijmo.angular2.core";
import { WjInputModule } from "wijmo/wijmo.angular2.input";
import { WjOlapModule } from "wijmo/wijmo.angular2.olap";
import {
  WjFlexGrid,
  WjFlexGridCellTemplate,
  WjGridModule,
} from "wijmo/wijmo.angular2.grid";
import { WjGridFilterModule } from "wijmo/wijmo.angular2.grid.filter";
import { WjGridSheetModule } from "wijmo/wijmo.angular2.grid.sheet";
import { GridPaginationComponent } from "./components/grid-pagination/grid-pagination.component";
import { GridToolbarComponent } from "./components/grid-toolbar/grid-toolbar.component";
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { GridComponent } from "./components/grid/grid.component";
import { SearchPipe } from "./pipe/search.pipe";
import { DatePipeProxy } from "./pipe/date.pipe";
import { KlIndicatorComponent } from "./components/kl-indicator/kl-indicator.component";
import { AutofocusDirective } from "./directives/autofocus.directive";
import { ConvertIsoDateService } from "@app/modules/shared/services/convert-iso-date.service";
import { GridPopupComponent } from "@app/modules/shared/components/grid-popup/grid-popup.component";
import { FormContainerComponent } from "@dashboard/components/form-container/form-container.component";
import { KlNumberInputDirective } from "./directives/kl-number-input.directive";
import { KlDropAndDragDirective } from "./directives/kl-drop-and-drag.directive";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { ClickOutsideDirective } from "./directives/outside-click.directive";
import { ExplorerService } from "@app/modules/shared/services/explorer.service";
import { KlLoadingComponent } from "@app/modules/shared/components/kl-loading/kl-loading.component";
import { FormEntryGridComponent } from "./components/form-entry-grid/form-entry-grid.component";
import { BillingPrepareCalculateService } from "@app/modules/shared/services/billing/billing-prepare-calculate.service";
import { UuidService } from "@app/modules/shared/services/uuid.service";
import { MaterialInfoService } from "@app/modules/shared/services/material/material-info.service";
import { JoinPipe } from "./pipe/join.pipe";
import { KlFastMaterialEntryComponent } from "./components/fast-material-entry/fast-material-entry.component";
import { KlAlertComponent } from "./components/alert/kl-alert.component";
import { KlAlertService } from "@app/modules/shared/services/message/alert.service";
import { KlPreferenceSaveFormComponent } from "./components/preference-form/kl-preference-save-form.component";
import { KlNotFoundComponent } from "./components/kl-not-found/kl-not-found.component";
import {
  NavDropDownDirective,
  NavDropDownToggleDirective,
} from "@app/modules/shared/directives/kl-nav.directive";
import {
  FullscreenDirective,
  MobileSidebarToggleDirective,
  SidebarMinimizeDirective,
  SidebarOffCanvasCloseDirective,
  SidebarToggleDirective,
} from "@app/modules/shared/directives/kl-sidebar.directives";
import { MouseOverDirective } from "@app/modules/shared/directives/outside-click.directive";
import { ItemHandleDirective } from "./directives/item-handle.directive";
import { SortableItemDirective } from "./directives/sortable-item.directive";
import {
  SortableConfig,
  SortableDefaultOptions,
} from "@app/modules/shared/services/sortable.config.service";
import { SortableHelper } from "@app/modules/shared/services/sortable.helper";
import { SortableService } from "@app/modules/shared/services/sortable.service";
import { DynamicFormComponent } from "@app/modules/shared/components/dynamic-form/dynamic-form.component";
import { TemplateRenderService } from "@app/modules/shared/services/template-render.service";
import { KlDetailFilterComponent } from "./components/kl-detail-filter/kl-detail-filter.component";
import { BillingCalculateService } from "@app/modules/shared/services/billing/billing-calculate.service";
import { KlOffClickOutsideDirective } from "./directives/kl-offclick-outside.directive";
import { KlReportFilterComponent } from "./components/kl-report-filter/kl-report-filter.component";
import { KlColumnPickerComponent } from "./components/kl-column-picker/kl-column-picker.component";
import { ReportToolbarComponent } from "./components/report-toolbar/report-toolbar.component";
import { GridDesignerComponent } from "./components/grid-designer/grid-designer.component";
import { KlFlexSheetComponent } from "./components/kl-flex-sheet/kl-flex-sheet.component";
import { KlReportViewerComponent } from "./components/kl-report-viewer/kl-report-viewer.component";
import { KlReportDesignerComponent } from "./components/kl-report-designer/kl-report-designer.component";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { KlTransactionComponent } from "./components/kl-transaction/kl-transaction.component";
import { ListboxModule } from "primeng/listbox";
import { ContextMenuComponent } from "./components/context-menu/context-menu.component";
import { ZipService } from "@app/modules/shared/services/zip.service";
import { ImageCropperModule } from "ngx-image-cropper";
import { KlImageCropperComponent } from "./components/kl-image-cropper/kl-image-cropper.component";
import { KlConfirmDialogComponent } from "./components/kl-confirm-dialog/kl-confirm-dialog.component";
import { KlConfirmDialogService } from "@app/modules/shared/services/kl-confirm-dialog.service";
import { SafeHtmlPipe } from "@app/modules/shared/pipe/safa-html.pipe";
import { LockScreenComponent } from "@app/modules/shared/components/lock-screen/lock-screen.component";
import { BsModalService, ModalModule } from "ngx-bootstrap/modal";
import { DropdownModule } from "primeng/dropdown";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { AutoCompleteModule } from "primeng/autocomplete";
import { CalendarModule } from "primeng/calendar";
import { TabsModule } from "ngx-bootstrap/tabs";
import { AlertModule } from "ngx-bootstrap/alert";
import { CheckboxModule } from "primeng/checkbox";
import { RadioButtonModule } from "primeng/radiobutton";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { SidebarModule } from "primeng/sidebar";
import { KlReportFilter2Component } from "./components/kl-report-filter2/kl-report-filter2.component";
import { KlReportComponent } from "./components/kl-report/kl-report.component";
import { DatePickerComponent } from "./components/date-picker/date-picker.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    WjCoreModule,
    WjGridModule,
    WjInputModule,
    WjOlapModule,
    WjGridFilterModule,
    WjGridSheetModule,
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    CalendarModule,
    ModalModule.forRoot(),
    AlertModule.forRoot(),
    AccordionModule.forRoot(),
    DropdownModule,
    SidebarModule,
    CheckboxModule,
    AutoCompleteModule,
    CollapseModule.forRoot(),
    TabsModule.forRoot(),
    RadioButtonModule,
    ListboxModule,
    ImageCropperModule,
  ],
  entryComponents: [],
  declarations: [
    TranslatePipe,
    SafeHtmlPipe,
    KlIndicatorComponent,
    GridContainerComponent,
    GridPaginationComponent,
    GridToolbarComponent,
    GridComponent,
    SearchPipe,
    JoinPipe,
    DatePipeProxy,
    KlIndicatorComponent,
    AutofocusDirective,
    GridPopupComponent,
    FormContainerComponent,
    KlNumberInputDirective,
    KlDropAndDragDirective,
    ClickOutsideDirective,
    KlLoadingComponent,
    FormEntryGridComponent,
    KlFastMaterialEntryComponent,
    KlAlertComponent,
    KlPreferenceSaveFormComponent,
    KlNotFoundComponent,
    NavDropDownDirective,
    NavDropDownToggleDirective,
    SidebarToggleDirective,
    SidebarMinimizeDirective,
    MobileSidebarToggleDirective,
    SidebarOffCanvasCloseDirective,
    MouseOverDirective,
    FullscreenDirective,
    ItemHandleDirective,
    SortableItemDirective,
    ItemHandleDirective,
    DynamicFormComponent,
    KlAlertComponent,
    KlDetailFilterComponent,
    KlOffClickOutsideDirective,
    KlReportComponent,
    KlReportFilterComponent,
    KlReportFilter2Component,
    KlColumnPickerComponent,
    ReportToolbarComponent,
    GridDesignerComponent,
    KlFlexSheetComponent,
    KlReportViewerComponent,
    KlReportDesignerComponent,
    KlTransactionComponent,
    ContextMenuComponent,
    KlImageCropperComponent,
    KlConfirmDialogComponent,
    LockScreenComponent,
    DatePickerComponent,
  ],
  exports: [
    // modules
    WjCoreModule,
    WjGridModule,
    WjFlexGrid,
    WjInputModule,
    WjOlapModule,
    WjGridFilterModule,
    WjFlexGridCellTemplate,
    WjGridSheetModule,
    AlertModule,
    CheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonsModule,
    CollapseModule,
    TooltipModule,
    AccordionModule,
    ModalModule,
    DropdownModule,
    CalendarModule,
    RadioButtonModule,
    BsDropdownModule,
    TabsModule,
    ListboxModule,
    FlexmonsterPivotModule,
    ImageCropperModule,

    // directives
    KlNumberInputDirective,
    KlDropAndDragDirective,
    ClickOutsideDirective,
    AutofocusDirective,
    KlOffClickOutsideDirective,
    NavDropDownDirective,
    NavDropDownToggleDirective,
    SidebarToggleDirective,
    SidebarMinimizeDirective,
    MobileSidebarToggleDirective,
    SidebarOffCanvasCloseDirective,
    MouseOverDirective,
    ItemHandleDirective,
    SortableItemDirective,
    ItemHandleDirective,
    FullscreenDirective,
    // pipes
    TranslatePipe,
    DatePipeProxy,
    SearchPipe,
    JoinPipe,
    TranslatePipe,
    // components
    KlLoadingComponent,
    KlIndicatorComponent,
    GridContainerComponent,
    GridPaginationComponent,
    GridToolbarComponent,
    GridComponent,
    KlReportFilterComponent,
    FormContainerComponent,
    FormEntryGridComponent,
    KlFastMaterialEntryComponent,
    KlAlertComponent,
    KlPreferenceSaveFormComponent,
    KlNotFoundComponent,
    DynamicFormComponent,
    KlAlertComponent,
    KlDetailFilterComponent,
    KlColumnPickerComponent,
    ReportToolbarComponent,
    GridDesignerComponent,
    KlFlexSheetComponent,
    KlReportViewerComponent,
    KlReportDesignerComponent,
    KlTransactionComponent,
    ContextMenuComponent,
    KlImageCropperComponent,
    KlConfirmDialogComponent,
    SafeHtmlPipe,
    KlReportComponent,
    KlReportFilter2Component,
    DatePickerComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        FormBuilder,
        {
          provide: ErrorHandler,
          useClass: GlobalErrorHandlerService,
        },
        UserService,
        UtilService,
        ApiService,
        TRANSLATION_PROVIDERS,
        TranslateService,
        ToastService,
        KlSweetAlertService,
        BsModalService,
        ConvertIsoDateService,
        KlLoadingService,
        ExplorerService,
        BillingPrepareCalculateService,
        UuidService,
        MaterialInfoService,
        KlAlertService,
        SortableDefaultOptions,
        SortableConfig,
        SortableHelper,
        SortableService,
        TemplateRenderService,
        BillingCalculateService,
        ZipService,
        KlConfirmDialogService,
      ],
    };
  }
}
